<template>
  <section class="ctn">
    <header v-if="showPage" class="header">
      <div class="flex-container">
        <section v-if="showPage" class="table">
          <heim-select
            label="Choisir un collaborateur"
            :data="names"
            label-key="name"
            value-key="id"
            v-model="nameId"
            @input="handleSelectEmployee"
          >
          </heim-select>
        </section>
        <router-link v-if="showPage" class="paper-action" to="/employees/new"><heim-icon icon="add"></heim-icon><span>{{ $t('info') }} {{ $t('contract') }}</span></router-link>
      </div>
    </header>

    <section v-if="showPage && !nameId" class="table">
      <header class="header left"><h1>Coûts pour le mois en cours</h1></header>
      <heim-table :data="employeesInfo" :columns="['month', 'price']" cols="2">
        <template slot="thead" slot-scope="props">
          <th>{{ $t('name') }}</th>
          <th class="" @click="props.sortBy('nb_days')">{{ $t('cost') }}</th>
          <th class="action edit"></th>
        </template>
        <template slot="tbody" slot-scope="{ item, index, show, openDetail, cols }">
          <tr>
            <td>{{ item.real_name }}</td>
            <td class="data">{{ item.price | currency }}</td>
            <td class="edit" data-title="Edit">
              <router-link class="paper-action" :to="{ path: `/employees/${item.id}/edit` }"><span>{{ $t('edit') }}</span><heim-icon class="icon" icon="chevron-right"></heim-icon></router-link>
            </td>
          </tr>
        </template>
      </heim-table>
    </section>
    <section v-if="showPage && nameId" class="table">
      <header class="header left"><h1>Informations pour {{ username }}</h1></header>
      <heim-table :data="employee" :columns="['month', 'price']" cols="2">
        <template slot="thead" slot-scope="props">
          <th>{{ $t('months') }}</th>
          <th class="" @click="props.sortBy('nb_days')">{{ $t('cost') }}</th>
          <th class="action edit"></th>
        </template>
        <template slot="tbody" slot-scope="{ item, index, show, openDetail, cols }">
          <tr>
            <td>{{ item.date | date }}</td>
            <td class="data">{{ item.price | currency }}</td>
            <td class="edit" data-title="Edit">
              <router-link class="paper-action" :to="{ path: `/employees/${item.id}/edit` }"><span>{{ $t('edit') }}</span><heim-icon class="icon" icon="chevron-right"></heim-icon></router-link>
            </td>
          </tr>
        </template>
      </heim-table>
    </section>

    <modal name="login" class="modal" height="auto" :click-to-close="false" @opened="opened">
      <form @submit.prevent="handleGetEmployees">
        <heim-input id="login" type="password" label="Mot de passe" name="password" v-model="password" v-validate="'required'"></heim-input>
        <footer class="flex-right">
          <router-link class="cost-cancel" to="/">Retour</router-link>
          <heim-button type="submit">Valider</heim-button>
        </footer>
      </form>
    </modal>

  </section>
</template>

<script>
import HeimIcon from "@/components/icon/heim-icon.vue";
import HeimInput from "@/components/form/input/text/heim-input.vue";
import HeimIconButton from "@/components/form/button/heim-icon-button.vue";
import HeimButton from "@/components/form/button/heim-button.vue";
import HeimTable from "@/components/layout/list/heim-table.vue";
import HeimSelect from "@/components/form/input/select/heim-select.vue";
import { mapState } from "vuex";

export default {
  name: 'EmployeesList',
  components: {
    HeimIcon,
    HeimInput,
    HeimIconButton,
    HeimButton,
    HeimTable,
    HeimSelect
  },
  async mounted() {
    if (this.employeePwd) {
      this.password = this.employeePwd;
      this.showPage = true;
      this.$store.dispatch("getAllEmployeesInfo", { password : this.password });
    } else {
      this.openModal();
    }
  },
  data() {
    return {
      nameId: "",
      password: "",
      showPage: false
    }
  },
  computed: {
    //Project id
    ...mapState({ employeePwd: state => state.employeePwd }),
    ...mapState({ projectId: state => state.projectId }),
    ...mapState({ names: state => state.employeesState.employees }),
    ...mapState({ employee: state => state.employeesState.employee }),
    ...mapState({ employeesInfo: state => state.employeesState.employeesInfo }),
    username() {
      if (this.nameId && this.names) {
        return this.names.filter(e => e.id == this.nameId)[0].name;
      }
      return "";
    }
  },
  methods: {
    openModal() {
      this.$modal.show('login');
    },
    //Give focus to input here, because with before-open event, modal not added to the DOM yet
    opened() {
      this.$el.querySelector("#login input").focus();
    },
    async handleGetEmployees() {
      const data = await this.$store.dispatch("getAllEmployeesInfo", { password : this.password });
      if (data) {
        this.$store.dispatch("getEmployees");
        this.$store.dispatch("setEmployeePwd", this.password);
        this.showPage = true;
        this.$modal.hide('login');
      } else {
        this.$store.dispatch("setToastMessage", {
          message: `Mot de passe invalide`
        });
        this.$store.dispatch("setToastMode", { mode: "error" });
        this.$store.dispatch("setOpenToast", { opened: true });
        this.password = "";
      }
    },
    handleSelectEmployee() {
      this.$store.dispatch("getEmployeeInfo", { id: this.nameId, password: this.password });
    }
  }
}
</script>

<style scoped>
/* Header */
.header .flex-container { width: 100%; }

/* select & margin table */
.flex-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.flex-container table { width: auto; }
.flex-container table .data { text-align: right; }

section.table { margin-bottom: 1rem; }

/* For the 'suivi realise' table */
table .row-list {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 0.35em 1.5em;
}

td.detail-row .item, .flex {
  display: flex;
  justify-content: space-between;
}
/* Suivi realise & suive restant */
.flex table {
  width: 49%;
}
</style>
<style src="@/assets/styles/modal.css"></style>